import axios from 'axios';
import { decamelizeObjKeys } from './CamelizeUtils';
import Configs from '~/configs.js';

const SERVER_URL = Configs.server.url;

function _requestUrl(endPoint, namedParams, userParams) {
  let endPointUrl = endPoint;
  const decamedNamedParams = decamelizeObjKeys(namedParams);
  Object.keys(decamedNamedParams).forEach(key => {
    endPointUrl = endPointUrl.replace(`:${key}`, decamedNamedParams[key]);
  });

  return `${SERVER_URL}${endPointUrl}`;
}

function _request(method, url, data) {
  return axios({
    method: method,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json',
    },
    params: method === 'GET' ? decamelizeObjKeys(data) : {},
    data: method === 'POST' ? data : {},
    url,
  });
}

export function get(endPoint, namedParams = {}, userParams = {}) {
  return _request('GET', _requestUrl(endPoint, namedParams), userParams);
}

export function post(endPoint, namedParams = {}, userParams = {}) {
  return _request('POST', _requestUrl(endPoint, namedParams), userParams);
}



// WEBPACK FOOTER //
// ./src/utils/WebRequestUtils.js